import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { SubscriptionApi } from "@/Modules/Models/Api/Subscription";
import type { Subscription } from "@/Modules/Models/Domain/Subscription";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import camelize from "@/Utils/Camelize";

const SubcriptionTransformer: TransformerExtended<Subscription, SubscriptionApi> = {
  ...DefaultTransformerGenerator<Subscription, SubscriptionApi>(),

  toDomain(value: SubscriptionApi): Subscription {
    return camelize<SubscriptionApi>(value) as Subscription;
  },
};

export type SubscriptionTransformerType = TransformerExtended<Subscription, SubscriptionApi>;

export default SubcriptionTransformer;
